import { authenticate } from "./auth";

const INTERVAL = 30000;

class KeepAliveService {
    #isEnabled = true;

    constructor() {
        this.timer = null;
        this.mouseMove = false;
        this.appIframe = null;
    }

    restart(appIframe = null) {
        if (!this.#isEnabled) { return; }
        this.kill();
        this.setAppListeners(appIframe);
        this.timer = setInterval(() => {
            if (this.mouseMove) {
                authenticate({ currLocation: location.href });
            }
            this.mouseMove = false;
        }, INTERVAL);
    }

    setAppListeners = (appIframe) => {
        if (!appIframe) { return; }
        this.appIframe = appIframe;
        this.appIframe.contentWindow.addEventListener('mousemove', this.onAppMouseMove);
    }

    enable(isEnable) {
        this.#isEnabled = isEnable;
        isEnable ? this.restart() : this.kill();
    }

    kill() {
        clearInterval(this.timer);
        this.mouseMove = false;
    }

    onAppMouseMove = () => {
        this.mouseMove = true;
    } 
}

export const keepAliveService = new KeepAliveService();